import React, { useState, useEffect } from 'react'
import ProjectLayout from '../../../../../layout/components/ProjectLayout'
import { useAlert } from '../../../../../context/AlertContext';
import { useParams } from 'react-router-dom'
import TaskListView from '../../tasks/components/TaskListView';
import TaskForm from '../../tasks/components/TaskForm';
import { useAppData } from '../../../../../context/AppDataContext';

import { useAuth } from '../../../../../context/AuthContext'; 
import TaskFilterToolBar from '../../tasks/hook/TaskFilterToolBar';
import { useTaskFilters } from '../../tasks/hook/useTaskFilter';
import TaskCardListView from '../../tasks/components/TaskCardListView';
import TaskCalendarView from '../../tasks/components/TaskCalendarView';
import { CalendarMonth, TableChart, ViewStream } from '@mui/icons-material';

function ProjectTaskListPage() {
    const { id } = useParams();
    const { taskList, getTaskList } = useAppData();
    const { authUser } = useAuth();
    const [selectedView,setSelectedView] = useState("card")

    const { 
        filteredList, activeFilter, isDropdownOpen, setIsDropdownOpen, handleFilterChange 
    } = useTaskFilters(taskList, authUser, id); // Pass 'id' to filter by project

    useEffect(() => { if (!taskList) getTaskList(); }, [id]);

    return (
        <ProjectLayout>
            <div className='row'>
                <div className='col-md-12'>
                    <div className='row align-items-center mb-0'>
                            
                            <div className='col-6'>
                                <div className="btn-group" role="group">
                                    <button type="button" className={selectedView === "card" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("card")}  ><ViewStream/> </button>
                                    <button type="button" className={selectedView === "tabular" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("tabular")}  ><TableChart/> </button>
                                    <button type="button" className={selectedView === "calendar" ? "btn btn-primary" : "btn btn-outline-primary"} onClick={()=>setSelectedView("calendar")}  ><CalendarMonth/></button>
                                </div>
                            </div>
                            <div className='col-6'>
                                <span className='float-end'><TaskForm callBack={getTaskList} projectId={id} /></span>
                            </div>
                            
                            
                        </div>

                    <div className='row mt-1'>
                        <TaskFilterToolBar 
                            activeFilter={activeFilter}
                            handleFilterChange={handleFilterChange}
                            isDropdownOpen={isDropdownOpen}
                            setIsDropdownOpen={setIsDropdownOpen}
                        />
                    </div>

                    <div className='row'>
                        <div className='col-md-12' style={{maxHeight:"80vh", overflow:"scroll" }}>
                            {selectedView === "tabular" && <TaskListView taskList={filteredList} callBack={getTaskList} /> }
                            {selectedView === "card" && <TaskCardListView taskList={filteredList} callBack={getTaskList} /> }
                            {selectedView === "calendar" && <TaskCalendarView taskList={filteredList} callBack={getTaskList} /> }
                        </div>
                    </div>

                    
                </div>
            </div>
        </ProjectLayout>
    );
}


export default ProjectTaskListPage